// eslint-disable-next-line import/no-cycle
import { BaseFieldConfig, ComponentNameEnum } from '@/types';

const conditionalDisplayFieldConfig: BaseFieldConfig = {
  componentName: ComponentNameEnum.FORM_FIELD_CONDITIONAL_DISPLAY,
  options: {},
};

export default conditionalDisplayFieldConfig;
